import React from "react";

const Misson = () => {
  return (
    <>
      <div className="w-full md:w-1/2 px-4 mb-8 md:mb-0">
        <div className="bg-white p-8 rounded-lg shadow-lg h-full">
          <h2 className="text-2xl font-bold mb-4 text-blue-400">Our Mission</h2>
          <p className="text-gray-700 leading-relaxed">
            As a growing company, we intend to take our staff and seafarers with
            us on this journey as we believe that 'a rising tide lifts all
            boats'
          </p>
        </div>
      </div>
    </>
  );
};

export default Misson;
